$(function(){
  // アイテムランク専用のモーダル
  var itemRankOpen = $('.item_rank .modal-open'),
    itemRankClose = $('.modal-container:not(.modal-condition-warranty) .modal-close'),
    itemRankContainer = $('.modal-container:not(.modal-condition-warranty)');

  //開くボタンをクリックしたらモーダルを表示する
  itemRankOpen.on('click',function(){ 
    itemRankContainer.addClass('active');
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  itemRankClose.on('click',function(){  
    itemRankContainer.removeClass('active');
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      itemRankContainer.removeClass('active');
    }
  });
});
